window.switchProductVariant = function (event) {
  event.preventDefault();
  const dataId = this.dataset.switcher;
  const switchers = this.closest('.js-preview-variants').children;
  const variants = this.closest('.js-product-preview').querySelectorAll('.product-preview__info')
  const activeProductPreview = this.closest('.js-product-preview').querySelector(`[data-variant="${dataId}"]`);

  for (let a = 0; a < switchers.length; a++) {
    switchers[a].classList.remove('active');
  }

  for (let a = 0; a < variants.length; a++) {
    variants[a].classList.remove('active');
  }

  this.classList.add('active')
  activeProductPreview.classList.add('active')
}

addMultiEventListenerByClass('DOMContentLoaded ajax:success jsRendered',
  '.js-variant-switcher', 'click', switchProductVariant)

window.addEventListener("popstate", function(e) {
  Rails.ajax({
    type: 'GET',
    url: location.pathname,
    success: function (data) {
      let product = document.querySelector('.js-product-wrapper');
      document.title = data.querySelector('title').textContent;
      document.head.querySelector('meta[name="description"]').setAttribute(
        "content", data.querySelector('meta[name="description"]').content);
      product.innerHTML = data.querySelector('.js-product-wrapper').innerHTML;
      fireJsRendered();
    }
  })
});
